import { Component } from "@builder.io/sdk";

export const locationCTAConfig: Component = {
  name: "Location CTA",
  inputs: [
    {
      name: "heading",
      type: "string",
      defaultValue: "Talk to a Care Expert",
      helperText: "The main heading text displayed in the CTA section",
    },
    {
      name: "image",
      type: "object",
      defaultValue: {
        src: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F89e121a6c263458ab7bb4d76b6f7b6ea",
        alt: "Locations CTA Image",
      },
      subFields: [
        {
          name: "src",
          type: "file",
          allowedFileTypes: ["jpeg", "png"],
          required: true,
          helperText: "URL or path to the image",
        },
        {
          name: "alt",
          type: "string",
          required: true,
          helperText: "Alt text for accessibility",
        },
        {
          name: "className",
          type: "string",
          helperText: "Optional CSS classes to apply to the image",
        },
      ],
    },
    {
      name: "cta",
      type: "object",
      defaultValue: {
        text: "Connect With Us",
        href: "/care-assessment",
      },
      subFields: [
        {
          name: "text",
          type: "string",
          required: true,
          helperText: "Text to display on the CTA button",
        },
        {
          name: "href",
          type: "string",
          required: true,
          helperText: "URL that the button links to",
        },
      ],
    },
  ],
};
